import React from 'react';

import {
  Grid, Skeleton,
} from '@mui/material';

import CommitForm from '../../../../components/CommitForm';
import ContentCard from '../../../../components/ContentCard';
import ProfileIcon from '../../../../components/ProfileIcon';
import { Class } from '../../../../services/classes/types';
import { useGetStaffQuery } from '../../../../services/staff';
import { Metadata } from '../../../../services/types';

interface ClassCardProps {
  classObj: Class;
  classObjMetadata?: Metadata;
}

const ClassCard = ({ classObj, classObjMetadata }: ClassCardProps) => {
  const { data: teacher, isLoading: isTeacherLoading } = useGetStaffQuery({
    staffId: classObj.teacher ?? '',
  });

  if (isTeacherLoading) {
    return (
      <Skeleton height={180} variant="rectangular" />
    );
  }

  return (
    <ContentCard>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} alignItems="center" justifyContent="center" display="flex">
          <ProfileIcon
            firstName={teacher?.data.firstName}
            lastName={teacher?.data.lastName}
            imageUrl={teacher?.data.profileIcon?.image}
            color={teacher?.data.profileIcon?.color}
            size={96}
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <CommitForm
            data={classObj}
            metadata={classObjMetadata}
            disabled
            fields={{
              teacher: {
                xs: 12,
                md: 12,
              },
              day: {
                xs: 12,
                md: 12,
              },
              time: {
                xs: 12,
                md: 12,
              },
            }}
          />
        </Grid>
      </Grid>
    </ContentCard>
  );
};
export default ClassCard;
